import { Admin } from '../../../../clients/quipli-service/admin/admin';
import { Typography } from '../../../../components/typography/typography';
import { toast } from '../../../../util/toasts';
import { AdminUserForm } from '../../components/admin-user-form';

export const AdminUserPassword = ({ adminUser }: { adminUser: Admin }) => {
  const update = () => {
    toast('User was updated successfully');
  };

  return (
    <div className="tab-section">
      <div className="tab-title">
        <Typography type="text-xl" weight="semi-bold">
          Change Password
        </Typography>
      </div>
      <AdminUserForm className="card" type="changePassword" setNewUser={update} adminUser={adminUser} />
    </div>
  );
};
